import React from 'react';
import { Card, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CompanyPortal } from '../../../../components';
import { getWorkspaceLanding } from '../../../../data/landing';

/**
 * หน้าแรกหลัง login ของคนที่สังกัดหลายบริษัท
 * เลือกบริษัท → เปิดเป็นแท็บแยกกัน แท็บนี้ค้างไว้เป็นแผงควบคุม
 */
function PortalPage() {
  const navigate = useNavigate();
  const userName = sessionStorage.getItem('userName');
  const role = sessionStorage.getItem('role');
  const jobType = Number(sessionStorage.getItem('jobType'));

  return (
    <div className="md:m-10 flex justify-center">
      <Card
        style={{ maxWidth: 560, width: '100%' }}
        title={<span>เลือกบริษัทที่จะเข้าทำงาน{userName ? ` — ${userName}` : ''}</span>}
      >
        <CompanyPortal />

        {/* เผื่อคนที่อยากทำงานในแท็บนี้เลย ไม่อยากเปิดแท็บใหม่ */}
        <Button
          type="link"
          block
          className="mt-3"
          onClick={() => navigate(getWorkspaceLanding({ role, jobType }))}
        >
          ข้ามไปก่อน เข้าทำงานในแท็บนี้
        </Button>
      </Card>
    </div>
  );
}

export default PortalPage;
